import  React, { useState, useRef, useEffect  } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Icons } from "../assest/icons";
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { logger } from '../utils/logger';
import Moment from 'react-moment';
import moment from 'moment';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import { updateUser } from '../services/firestore';
import { saveFHIRPatient } from '../services/fhirService';

import { ToastContainer, toast } from "react-toastify";
import LeftSideLogin from "./leftsidelogin";
import { isValidNewPassword } from '../utils/passwordValidation';


function SingupFillUserInfo() {  
  const location = useLocation(); 
  const [data, setdata] = useState(location.state); 
  const userDataInfo =  JSON.parse(localStorage.getItem('UserProfile')) || {};
 
  let navigate = useNavigate();
  const [showCalendar, setShowCalendar] = useState(false);

  const [UserData, setUserData] = useState([]);

  const [ShowLoader, setShowLoader] = useState(false);

  const [UserId, setUserId] = useState(userDataInfo?.user_id || userDataInfo?.id || '');
  const [firstStep, setFirstStep] = useState(false);
  const [twoStep, setTwoStep] = useState(false);
  const [threeStep, setThreeStep] = useState(true);
  const [finalStep, setFinalStep] = useState(false);

  const [fullName, setFullName] = useState(userDataInfo?.fullName || '');
  const [email, setEmail] = useState(userDataInfo?.email || '');
  const [phoneNumber, setPhoneNumber] = useState(userDataInfo?.phoneNumber || '');
  const [password, setPassword] = useState('');
  const [selectedToggle, setSelectedToggle] = useState(true);
  const [DOBTxt, setDOBTxt] = useState('');
  const [GenderTxt, setGenderTxt] = useState('');
  const [InsuranceIdTxt, setInsuranceIdTxt] = useState('');
  const [ClearBtn, setClearBtn] = useState(false);

  const [AgeTxt, setAgeTxt] = useState('');
  const [WeightTxt, setWeightTxt] = useState('');
  const [HeightTxt, setHeightTxt] = useState('');

  const [errors, setErrors] = useState({});
  const [isValid, setIsValid] = useState(false);
  const [CheckLogin, setCheckLogin] = useState(userDataInfo?.login_from || '');
  
  const [focused, setFocused] = React.useState(false); 
  const [errorMessage, setErrorMessage] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);

  function handleOnFocus() {
    setFocused(true);
  }

  function handleOnBlur() {
    setFocused(false);
  }


  const nav = useNavigate();
  const routeChange = () =>{
    localStorage.setItem('UserLoginStatus',  JSON.stringify(true) );
    sessionStorage.setItem('aigi_session_alive', 'true');
    // nav("/dashboard", { state:UserData});
    nav("/addinsuranceinfo", { state:UserData});
  }
  const handleResetFormStart= () => {
    setFullName('');
    setEmail('');
    setPhoneNumber('');
    setPassword(''); 
    setErrors('');
  };
  const handleResetForm1 = () => { 
    setPassword(''); 
    setErrors('');
  };
  const handleResetForm2 = () => { 
    setDOBTxt('');
    setGenderTxt('');
    setInsuranceIdTxt('');
    setErrors('');
  }; 
  const handleOptionChangeToogle = () => {
    setSelectedToggle(!selectedToggle); 
  };
  const handleClickFirst = () => {
    setFirstStep(false);
    setTwoStep(false);
    setThreeStep(true);
    setFinalStep(false);
  };  
 
  const handleClickThree = () => {
    setFirstStep(false);
    setTwoStep(false);
    setFinalStep(true);
    setThreeStep(false);
  };
  const handleClickFinal = () => {
    setFirstStep(false);
    setTwoStep(false);
    setFinalStep(true);
    setThreeStep(false);
  };

const handleFullNameChange = (event) => {
  // Remove non-text characters from the input value
  const value = event.target.value.replace(/[^a-zA-Z\s]/g, '');
  setFullName(value);
  setErrors('');
};

 
    const isValidEmail = (email) => {
      // Regular expression to validate email format
      const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return regex.test(email);
    };
    const isValidDateFormat = (dateString) => {
      const regex = /^\d{4}-\d{2}-\d{2}$/;
      return regex.test(dateString);
  };
  const onChangeCalendar = (date) => {     
    setDOBTxt(formatDate(date));
    setShowCalendar(false);
    setErrors('');
};
  const toggleCalendar = () => {
    setShowCalendar(!showCalendar);
};
    const handleClearDate = () => {
      setClearBtn(false);
      // Clear the date by setting the dob state to an empty string
      setDOBTxt('');
  };
 
  const handleGenderChange = (e) => {
    setGenderTxt(e.target.value); 
  };
//   const handleGenderChange = (event) => {
//     let { value } = event.target; 
//         // Allow delete action
//         if (value === '') {
//           setGenderTxt(''); 
//       } 
//       // Convert input to uppercase for comparison
//       value = value.toUpperCase();
//     // Allow only 'M' or 'F' characters
//     if ( value === 'M' || value === 'F') { 
//         setGenderTxt(value === 'M' ? 'Male' :  'Female');
//     }
// }; 
const handleSubmitPart2 = async (event) => {
  let newDOBTxt = '';
      event.preventDefault(); 
      // Simple form validation
      let formErrors = {}; 
      setErrorMessage('');
      // Set form as submitted
      setIsSubmitted(true);
  
    
      // Check if all date parts (YYYY, MM, DD) are filled out
      if (!YYYYTxt.trim() || !MMTxt.trim() || !DDTxt.trim()) {
        formErrors.DOBTxt = 'Please select a complete date (YYYY/MM/DD)';
      } else {
        // Validate each part
        const currentYear = moment().year();
        const year = parseInt(YYYYTxt, 10);
        const month = parseInt(MMTxt, 10);
        const day = parseInt(DDTxt, 10);

        if (isNaN(year) || year > currentYear) {
          formErrors.DOBTxt = 'Year cannot be in the future';
        } else if (isNaN(month) || month < 1 || month > 12) {
          formErrors.DOBTxt = 'Invalid month. Month must be between 1 and 12';
        } else if (isNaN(day) || day < 1 || day > 31) {
          formErrors.DOBTxt = 'Invalid day. Day must be between 1 and 31';
        } else {
          // Create DOBTxt from the validated year, month, and day
          const date = moment(`${YYYYTxt}-${MMTxt}-${DDTxt}`, 'YYYY-MM-DD');
          if (!date.isValid()) {
            formErrors.DOBTxt = 'Invalid date. Please check your input';
          } else if (date.isAfter(moment(), 'day')) {
            formErrors.DOBTxt = 'Date of birth cannot be in the future';
          } else if (moment().diff(date, 'years') < 18) {
            formErrors.DOBTxt = 'You must be at least 18 years old to register';
          } else {
            newDOBTxt = date.format('YYYY-MM-DD'); // Store the formatted date
            setDOBTxt(newDOBTxt); // Update the state
          }
        }
      }

      if (!GenderTxt.trim()) {
          formErrors.GenderTxt = 'Please enter your sex';
      }
      // if (!InsuranceIdTxt.trim()) {
      //     formErrors.InsuranceIdTxt = 'Please enter your Insurance ID';
      // }   
      if (Object.keys(formErrors).length > 0) {
          setErrors(formErrors);
          return;
      }

      setShowLoader(true)
      // If validation passes, update user data in Firestore
      const dataReq = {
        fullName: fullName,
        email: email,
        phoneNumber: phoneNumber,
        dob: newDOBTxt,
        gender: GenderTxt
    };
    
    try {
      // Update user in Firestore
      await updateUser(UserId, dataReq);

      // FHIR: Update Patient resource (fire-and-forget)
      saveFHIRPatient(dataReq, UserId);

      toast.success("User profile update successfully!", {
        position: toast.POSITION.TOP_RIGHT,
      });
      
      // Update local storage with new data
      const updatedProfile = { ...userDataInfo, ...dataReq, user_id: UserId };
      localStorage.setItem('UserProfile', JSON.stringify(updatedProfile));
      setUserData(updatedProfile);
      
      setShowLoader(false);
      routeChange();
      handleResetForm2();
    } catch (error) {
      logger.error('Error updating user:', error);
      toast.error(error.message || "Failed to update profile. Please try again.", {
        position: toast.POSITION.TOP_RIGHT,
      });
      setShowLoader(false);
    }
  };
  const formatDate = (date) => { 
    return date ? moment(date).format("YYYY-MM-DD") : '';
};
const disablePastDates = ({ activeStartDate, date, view }) => {
  // Disable dates before the current date
return date >= new Date();
 // return date.getMonth() > new Date().getMonth() || date.getFullYear() > new Date().getFullYear() || date >= new Date();
};


const InsuranceIdHandleChange = (e) => {
  // Get the new value
  const value = e.target.value;    

  // Regex to allow only alphanumeric characters, hyphens, and spaces
  const regex = /^[\w\s-]*$/;

  if (value === '' || regex.test(value)) {
    let newValue = value.replace(/\s+/g, ' '); 
    setInsuranceIdTxt(newValue);
  } 

};

const yearRef = useRef(null);
const monthRef = useRef(null);
const dayRef = useRef(null);
  
const [YYYYTxt, setYYYYTxt] = useState('');
const [MMTxt, setMMTxt] = useState('');
const [DDTxt, setDDTxt] = useState('');

const handleInput = (e, nextRef, prevRef, setState) => {
  let value = e.target.value;
  const fieldName = e.target.placeholder;
  // Reset submission flag when user types
  setIsSubmitted(false);
  
 
    // Update the state as the user types
    setState(value);

 

  // Forward jump when the max length is reached
  if (value.length === e.target.maxLength) {
    // Year Validation (YYYY)
    if (fieldName === "YYYY") {
      const currentYear = moment().year();
      if (parseInt(value, 10) > currentYear) {
        setErrorMessage("Year cannot be more than the current year");
        yearRef.current.focus();
        return;
      }
    }

    // Month Validation (MM)
    if (fieldName === "MM") {
      if (parseInt(value, 10) < 1 || parseInt(value, 10) > 12) {
        setErrorMessage("Month must be between 1 and 12");
        monthRef.current.focus();
        return;
      }
    }

    // Day Validation (DD)
    if (fieldName === "DD") {
      if (parseInt(value, 10) < 1 || parseInt(value, 10) > 31) {
        setErrorMessage("Day must be between 1 and 31");
        dayRef.current.focus();
        return;
      }
    }

    // Clear error message if validation passes
    setErrorMessage("");
    if (nextRef) {
      nextRef.current.focus();
    }
  } 
  // Backward jump when "Backspace" is pressed and the input is empty
  else if (e.nativeEvent.inputType === "deleteContentBackward" && value.length === 0) {
    if (prevRef) {
      prevRef.current.focus();
    }
  }
 
};

  

const handleKeyDown = (e, nextRef, prevRef, setState) => {
  const value = e.target.value;
  const fieldName = e.target.placeholder;

  // Handle Right Arrow Key
  if (e.key === "ArrowRight") {
    if (value === "") {
      setErrorMessage(`${fieldName} cannot be empty`);
      e.target.focus();
      return;
    } else {
      setErrorMessage(""); // Clear error if field is not empty
    }

    // Check for single-digit values in MM and DD
    if ((fieldName === "MM" || fieldName === "DD") && value.length === 1) {
      const paddedValue = `0${value}`; // Add leading zero
      setState(paddedValue); // Update state
      e.target.value = paddedValue; // Update input value
    }

    if (nextRef) {
      nextRef.current.focus();
    }
  }

  // Handle Left Arrow Key
  if (e.key === "ArrowLeft") {
    if (value === "") {
      setErrorMessage(`${fieldName} cannot be empty`);
      e.target.focus();
      return;
    } else {
      setErrorMessage(""); // Clear error if field is not empty
    }

    // Check for single-digit values in MM and DD
    if ((fieldName === "MM" || fieldName === "DD") && value.length === 1) {
      const paddedValue = `0${value}`; // Add leading zero
      setState(paddedValue); // Update state
      e.target.value = paddedValue; // Update input value
    }

    if (prevRef) {
      prevRef.current.focus();
    }
  }
};

const handleBlur = (e, setState) => {
  const value = e.target.value;

  // Check if the value is a single digit
  if (value.length === 1 && parseInt(value, 10) > 0) {
    const paddedValue = `0${value}`; // Add leading zero
    setState(paddedValue); // Update state
    e.target.value = paddedValue; // Update input value
  }
};
  return (
    <div>
      <div className='container-fluid p-0 bgImageUrl'>
       
        <div className='container p-0 contentBody loginScreen'>

       <LeftSideLogin/>
          <div className="col-lg-5 d-inline-block position-relative">
            <div className="loginBoxDiv">
            {
              threeStep ? (<>
               <div className={"singUpThreeStep " }>
              <h3 className="titleDespTxt">Please fill details to continue</h3>
                <form  onSubmit={handleSubmitPart2} autoComplete="off">
                  <div className={"inputTxtBox registerInputDiv "+ (fullName.length > 0 ? 'disabled' : '')}>
                    <img src={Icons[0].userImg} className="logoImg" alt="" />
                    <input type="text" value={fullName} placeholder="Full Name"  readOnly />
                  </div>
                  <div className={"inputTxtBox registerInputDiv "+ (email.length > 0 ? 'disabled' : '')}>
                    <img src={Icons[0].mailImg} className="logoImg" alt="" />
                    <input type="text" value={email} placeholder="Email id" readOnly  /> 
                  </div>
                  <div className={"registerInputDiv "+ 
                     (CheckLogin === 'google' && phoneNumber.length === 0 ? '' : 'disabled'  )
                    //  (CheckLogin != 'google'? (phoneNumber.length > 0 ? 'disabled' : '') :('')) 
                     }>
                    <PhoneInput
                      defaultCountry="US"
                      country={"us"}
                     id="phone"
                     placeholder="Enter phone number"
                     value={phoneNumber}
                     onChange={setPhoneNumber} 
                     international={false}
                     error={!isValid && phoneNumber.trim().length > 0}
                     onBlur={() => setIsValid(!!phoneNumber.trim())}
                     inputProps={{
                       name: 'phone',
                       required: true,
                       autoFocus: true
                     }}  
                     readOnly 
                    />
                  </div> 
                      <div className="inputTxtNewBox  registerInputDiv">
                        <img src={Icons[0].dateIcon} className="logoImg" alt="" />
                        <div className="timepicker">
                              <input
                                type="text"
                                className="hh"
                                maxLength="4"
                                placeholder="YYYY"
                                ref={yearRef}
                                onInput={(e) => handleInput(e, monthRef, null, setYYYYTxt)}
                                onKeyDown={(e) => handleKeyDown(e, monthRef, null)}
                              />
                              /
                              <input
                                type="text"
                                className="mm"
                                maxLength="2"
                                placeholder="MM"
                                ref={monthRef}
                                  onInput={(e) => handleInput(e, dayRef, yearRef, setMMTxt)}
                                  onKeyDown={(e) => handleKeyDown(e, dayRef, yearRef, setMMTxt)}
                              />
                              /
                              <input
                                type="text"
                                className="mm"
                                maxLength="2"
                                placeholder="DD"
                                ref={dayRef}
                                onInput={(e) => handleInput(e, null, monthRef, setDDTxt)}
                                onKeyDown={(e) => handleKeyDown(e, null, monthRef, setDDTxt)}
                                onBlur={(e) => handleBlur(e, setDDTxt)} // Add onBlur event
                              />
                            <b style={{fontWeight:'500',fontSize: '14px', color:'#999'}}>Date of Birth</b>
                            </div>        
                        {/* <input type="text"    value={DOBTxt} placeholder="Date of Birth (YYYY-MM-DD)" readOnly /> 
                        <button className="toggleCalendarBtn"  onClick={toggleCalendar}> <img src={Icons[0].calendarIcon} className="logoImg" alt="" /></button>
                          {showCalendar && (
                              <Calendar 
                                className= 'inputCaledar' 
                                onChange={onChangeCalendar}
                                value={DOBTxt}
                                maxDate={new Date()} 
                                tileDisabled={disablePastDates}
                                />
                          )} */}
                   </div>
                
                  {isSubmitted && errors.DOBTxt ? (
                    <span className="errorTxt">{errors.DOBTxt}</span>
                  ) : (
                    !isSubmitted && errorMessage && <span className="errorTxt">{errorMessage}</span>
                  )}
                      <div className="inputTxtBox  registerInputDiv d-flex justify-content-start">
                        <img src={Icons[0].GenderImg} className="logoImg" alt="" />
                        {/* <input type="text" value={GenderTxt} placeholder="Sex" onChange={handleGenderChange} maxLength="1"   
                        onKeyUp={(e) => { if (e.key === 'Backspace') { setGenderTxt('');  } }}/>  */}
                               <div className="gender-selector  d-flex justify-content-between ">
                            <label className="d-flex align-items-center">
                              <input
                                type="radio"
                                value="Male"
                                checked={GenderTxt === 'Male'}
                                onChange={handleGenderChange}
                              />
                              Male
                            </label>
                            <label  className="d-flex align-items-center">
                              <input
                                type="radio"
                                value="Female"
                                checked={GenderTxt === 'Female'}
                                onChange={handleGenderChange}
                              />
                              Female
                            </label>
                            {/* <label>
                              <input
                                type="radio"
                                value="Other"
                                checked={GenderTxt === 'Other'}
                                onChange={handleGenderChange}
                              />
                              Other
                            </label> */}
                          </div>
                  </div>
                  {errors.GenderTxt && <span  className="errorTxt" >{errors.GenderTxt}</span>} 

{/* 
                  <div className="inputTxtBox registerInputDiv">
                    <img src={Icons[0].InsuranceIDIcon} className="logoImg" alt="" />
                    <input type="text" 
                    value={InsuranceIdTxt} 
                    placeholder="Insurance ID" 
                    maxLength="20" 
                    // onChange={(e) => setInsuranceIdTxt(e.target.value)}  
                    onChange={InsuranceIdHandleChange}
                     /> 
                  </div>
                  {errors.InsuranceIdTxt && <span  className="errorTxt" >{errors.InsuranceIdTxt}</span>}  */}
                   
                  {ShowLoader ? (<>
                      <button  className="signInBtn" > Loading
                      <div className="spinner-border text-light  " role="status">
                       <span className="visually-hidden">Loading...</span>
                    </div> 
                    </button>
                    </>):(<>
                      <button className="signInBtn registerBtn mb-0" >Continue</button>
                    </>)}
              </form>
              </div>
              </>):(<>
                <div className={"singUpFinalStep  " }>
                    <span className="emailVerificationDiv">
                    <img src={Icons[0].checkedIcon} className="logoImg" alt="" />
                    <h3>Success!</h3>
                    <p>Congratulations! Your account has beed created successfully. Continue to the dashboard.</p>
                    <button className="signInBtn mb-0"   onClick={routeChange} >Continue</button>
               
                    </span>
              </div>
              </>)
            }
           
              
            </div>

           
          </div>
          
        </div>
      
      </div>
    </div>
  );
}

export default SingupFillUserInfo;